import { Grid, Box, styled, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IHarvestBotCustomize } from 'wisestep-api';
import {
  ControlledTextInput,
  WsButtonGroupInput,
  WsColors,
  WsSelect,
  WsInputNumber,
  WsButton,
} from 'wisestep-base';

import { WsSkillsFilter } from '../../../../components/filters/skillsFilter';
import {
  BotAdvCustomizationFormProps,
  downloadSettings,
  notifyVia,
  profiles,
  sourceAfter,
  stopAfter,
  timeTypeDropDownOptions,
} from '../BotsHelper';

interface BotCustomizationFormProps {
  onSubmit: (data: BotAdvCustomizationFormProps) => void;
  defaultValuesObj: IHarvestBotCustomize;
  onClose: () => void;
}

const BotCustomizationForm = ({
  onSubmit,
  onClose,
  defaultValuesObj,
}: BotCustomizationFormProps) => {
  const [isCustom, setIsCustom] = useState(false);
  const DrawerFooter = styled(Grid)(() => ({
    position: 'fixed',
    bottom: 1,
    width: '30vw',
    justifyContent: 'revert',
    background: WsColors.TertiaryShades100,
  }));

  const methods = useForm<BotAdvCustomizationFormProps>();
  return (
    <FormProvider {...methods}>
      <Grid container justifyContent="center">
        <Box component="form" role="presentation" onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid mx={2} mb={2}>
            <Grid mt={2}>
              <ControlledTextInput
                name="name"
                type="text"
                labelText=" Name:"
                fullWidth
                placeholder="Name"
                variant="outlined"
                defaultValue={defaultValuesObj.name ?? ''}
              />
            </Grid>
            <Grid mt={2}>
              <WsSkillsFilter
                name="skills"
                placeHolder="eg. JAVA,Leadership..."
                label="Enter must have skills:"
              />
            </Grid>
            <Grid mt={2}>
              <WsButtonGroupInput
                buttonsList={profiles}
                inputTitle="Sort Profiles By:"
                defaultValue={profiles.findIndex((p) => p.value === 'activityDate')}
                selectedIndexValue={(index, value) => {
                  methods.setValue('sortBy', `${value.value}`);
                }}
              ></WsButtonGroupInput>
            </Grid>
            <Grid mt={2}>
              <WsButtonGroupInput
                buttonsList={downloadSettings}
                inputTitle="Download Settings:"
                defaultValue={downloadSettings.findIndex(
                  (p) => p.value === defaultValuesObj.autoDownload
                )}
                selectedIndexValue={(index, value) =>
                  methods.setValue('autoDownload', value.value ? true : false)
                }
              ></WsButtonGroupInput>
            </Grid>
            {defaultValuesObj.autoDownload && (
              <Grid mt={2}>
                <ControlledTextInput
                  name="downloadLimit"
                  label="Limit Downloads:"
                  type="number"
                  fullWidth
                  placeholder="Limit Downloads"
                  variant="outlined"
                  defaultValue={defaultValuesObj.downloadLimit}
                />
              </Grid>
            )}
            <Grid mt={2}>
              <WsButtonGroupInput
                buttonsList={sourceAfter}
                inputTitle="Source After:"
                defaultValue={sourceAfter.findIndex(
                  (p) => p.value === defaultValuesObj.harvestingInterval
                )}
                selectedIndexValue={(index, value) => {
                  const arr = `${value.value}`.split('-');
                  const val = arr[1] == 'DAY' ? `${arr[0]}D` : `${arr[0]}H`;
                  methods.setValue('harvestingInterval', val ?? '1H');
                  methods.setValue('intervalType', `${arr[1]}`);
                }}
              ></WsButtonGroupInput>
            </Grid>

            <Grid mt={2}>
              <WsButtonGroupInput
                buttonsList={stopAfter}
                inputTitle="Stop Harvest After:"
                defaultValue={stopAfter.findIndex((p) => p.value === defaultValuesObj.stopAfter)}
                selectedIndexValue={(index, value) => {
                  const arr = `${value.value}`.split('-');
                  methods.setValue('stopAfterType', `${arr[1]}`);
                  if (value.value === 'CUSTOM') {
                    methods.setValue('stopAfter', value.value);
                    setIsCustom(true);
                  } else {
                    methods.setValue('stopAfter', `${arr[0] ?? '6H'}`);
                    setIsCustom(false);
                  }
                }}
              ></WsButtonGroupInput>
            </Grid>
            {isCustom && (
              <Grid item container xs={12} display="flex" columnGap={1} mt={2}>
                <Grid item xs={6}>
                  <WsInputNumber
                    name="stopAfterUnit"
                    defaultValue={Number(defaultValuesObj.stopAfterUnit)}
                  />
                </Grid>
                <Grid item xs={5.5}>
                  <WsSelect name="stopAfterType" selectArray={timeTypeDropDownOptions} />
                </Grid>
              </Grid>
            )}

            <Grid mt={2}>
              <WsButtonGroupInput
                buttonsList={notifyVia}
                inputTitle="Nofify Via:"
                defaultValue={notifyVia.findIndex((p) => p.value === defaultValuesObj.notification)}
                selectedIndexValue={(index, value) =>
                  methods.setValue('notification', `${value.value}`)
                }
              ></WsButtonGroupInput>
            </Grid>
          </Grid>
          <DrawerFooter>
            <Stack p={1} columnGap={2} direction="row" justifyContent="flex-end">
              <WsButton variant="outlined" size="large" onClick={() => onClose()}>
                Back
              </WsButton>
              <WsButton variant="contained" size="large" type="submit">
                Start Sourcing
              </WsButton>
            </Stack>
          </DrawerFooter>
        </Box>
      </Grid>
    </FormProvider>
  );
};

export default BotCustomizationForm;
